import 'html/include/js/om/om';
import 'html/include/js/zepto.min';
import 'html/include/js/jquery.unveil';
import SerpReviews from '@atomic/organisms/serp/reviews';
import SerpContactSection from '@atomic/organisms/serp/contact-section';
import AOSerpFAQs from '@atomic/organisms/serp/faqs';
import AOTruncateText from '@atomic/organisms/truncate-text/truncate-text';
import AOCarouselSlider from '@atomic/organisms/serp/carousel-slider';
import {
  byUserInteraction,
  byWindowAction,
  exposeSerpManualRankingExperiment,
  getBreakpointMinWidth,
  initializeAmplitudeSync,
  initializeSaleTopBanner,
  initiateAppBanner,
  initLazyLoad,
  initUserInteraction,
  initWindowAction,
  loadAsyncCss,
  parameters,
  sendAmplitudeEvent,
  sendGoogleEvent,
} from '@html/_common/utils';
import { lighthouseNavigationInitiate, trustBannerInitiate } from '@html/_common/header_script';
import LiveChat from '@html/_modules/live-chat';
import AOStickyMenu from '@atomic/organisms/sticky-menu/sticky-menu';

export default function LighthouseScript() {
  const MOBILE_WIDTH = getBreakpointMinWidth('s2') - 1;

  const IMAGE_SIZES = {
    mobile: '360x210',
    desktop: '1171x320',
  };

  const isInMobileWidth = (width) => width <= MOBILE_WIDTH;
  const $mapImages = $('.js-tour-card-images__map-link__picture--full-width');

  const stickyMenu = new AOStickyMenu();
  stickyMenu.initiate();

  const reviews = new SerpReviews();
  reviews.initiate();

  const contactSection = new SerpContactSection();
  contactSection.initiate();

  const faqs = new AOSerpFAQs();
  faqs.initiate();

  const truncateText = new AOTruncateText();
  truncateText.initiate();

  const carouselSlider = new AOCarouselSlider();
  carouselSlider.initiate();

  let selectedMonth = 'initial';
  const initializeLazyLoadedBackgroundImagesObserver = () => {
    const lazyBackgrounds = [].slice.call(document.querySelectorAll('.ao-lazy-background'));

    if ('IntersectionObserver' in window) {
      const lazyBackgroundObserver = new IntersectionObserver(((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('ao-lazy-background--visible');
            lazyBackgroundObserver.unobserve(entry.target);
          }
        });
      }));

      lazyBackgrounds.forEach((lazyBackground) => {
        lazyBackgroundObserver.observe(lazyBackground);
      });
    }
  };

  const uncriticalCSSFallbackLoad = () => {
    const uncriticalCssElem = document.getElementById('async-uncritical-css');

    if (uncriticalCssElem?.getAttribute('rel') === 'preload') {
      uncriticalCssElem.rel = 'stylesheet';
    }
  };
  const goToSerp = (link) => {
    let serpLink = link.replaceAll('@', '/');
    if (selectedMonth !== 'initial') {
      serpLink = `${serpLink}#month=${selectedMonth}`;
    }
    window.location.href = serpLink;
  };

  const handleInteraction = () => {
    const $asyncCssPathElem = $('#async_css_path');
    loadAsyncCss($asyncCssPathElem.val());
    ['scroll', 'keydown', 'keyup', 'mousemove', 'touchend', 'touchmove'].forEach((e) => {
      window.removeEventListener(e, handleInteraction);
    });
  };

  const getDeviceType = (width) => {
    if (isInMobileWidth(width)) {
      return 'mobile';
    }
    return 'desktop';
  };

  const initResizeMap = () => {
    const currentPageWidth = $(window).width();

    const deviceType = getDeviceType(currentPageWidth);
    const imageSizeToUse = IMAGE_SIZES[deviceType];

    $mapImages.each((index, item) => {
      const currentImageUrl = $(item).attr('src');
      const currentDataImageUrl = $(item).data('src');

      // eslint-disable-next-line prefer-regex-literals
      const regex = new RegExp('\\/\\d+x\\d+\\/');
      const newImageUrl = currentImageUrl.replace(regex, `/${imageSizeToUse}/`);
      const newImageDataUrl = currentDataImageUrl.replace(regex, `/${imageSizeToUse}/`);

      $(item).attr('src', newImageUrl);
      $(item).data('src', newImageDataUrl);
    });
  };

  const initResizeMapInit = () => {
    if ($mapImages.length === 0) {
      return;
    }

    if (isInMobileWidth) {
      initResizeMap();
    }

    byWindowAction(['resize'], () => {
      initResizeMap();
    });
  };

  this.initiate = () => {
    if (document.readyState !== 'loading') {
      initializeLazyLoadedBackgroundImagesObserver();
      uncriticalCSSFallbackLoad();
    } else {
      document.addEventListener('DOMContentLoaded', initializeLazyLoadedBackgroundImagesObserver);
      document.addEventListener('DOMContentLoaded', uncriticalCSSFallbackLoad);
    }

    const monthSelectElement = document.querySelector('.js-aa-dropdown');
    if (monthSelectElement) {
      monthSelectElement.addEventListener('change', (event) => {
        selectedMonth = event.target.value;
      });
    }

    const serpTopButton = document.querySelector('.js-serp-top-button');
    const serpCtaButtons = document.querySelectorAll('.js-serp-cta-button');
    const serpSliderCtaButton = document.querySelector('.js-ao-clp-carousel-slider__navigation-see-all-tours');

    if (serpTopButton) {
      serpTopButton.addEventListener('click', () => {
        goToSerp(serpTopButton.dataset.serp);
      });
    }

    if (serpCtaButtons) {
      serpCtaButtons.forEach((serpCtaButton) => {
        serpCtaButton.addEventListener('click', () => {
          goToSerp(serpCtaButton.dataset.serp);
        });
      });
    }

    if (serpSliderCtaButton) {
      serpSliderCtaButton.addEventListener('click', () => {
        goToSerp(serpSliderCtaButton.dataset.cta);
      });
    }

    document.querySelectorAll('.js-timeline-show-more').forEach((timelineShowMoreButton) => {
      timelineShowMoreButton.addEventListener('click', (e) => {
        const $clickedShowMore = $(e.currentTarget);
        $clickedShowMore.addClass('hid');
        const $parent = $clickedShowMore.parent();
        const timelineElements = $parent.find('.scout-timeline__item');
        $(timelineElements).removeClass('scout-timeline__item-no-distance');
        $(timelineElements).removeClass('scout-timeline__item-hid');
      });
    });

    $('.js-lac-links-month-button').on('click', (event) => {
      event.preventDefault();
      window.location.href = event.currentTarget.getAttribute('data-link').replaceAll('@', '/');
    });

    $('.js-ao-serp-demographic-links__card-button').on('click', (event) => {
      event.preventDefault();
      window.location.href = event.currentTarget.getAttribute('data-link').replaceAll('@', '/');
    });

    $('.js-scout-component-mini-card__button').on('click', (event) => {
      event.preventDefault();
      window.location.href = event.currentTarget.getAttribute('data-link').replaceAll('@', '/');
    });

    $('.js-ao-category-links__more-button').on('click', (event) => {
      event.preventDefault();
      window.location.href = event.currentTarget.getAttribute('data-link').replaceAll('@', '/');
    });

    $('.js-ao-season-month__card__months-item__header-button').on('click', (event) => {
      event.preventDefault();
      window.location.href = event.currentTarget.getAttribute('data-link').replaceAll('@', '/');
    });
    $('.js-link-to-button').on('click', (event) => {
      event.preventDefault();
      window.location.href = event.currentTarget.getAttribute('data-link').replaceAll('@', '/');
    });

    $('.js-ao-clp-carousel-slider__navigation-see-all-tours').on('click', (event) => {
      event.preventDefault();
      window.location.href = event.currentTarget.getAttribute('data-cta-button').replaceAll('@', '/');
    });

    const heroAnchor = document.querySelector('.hero');
    const itinerayHeroAnchor = document.querySelector('.itinerary-hero');

    if (heroAnchor) {
      heroAnchor.addEventListener('click', (e) => {
        e.preventDefault();
      });
    }

    if (itinerayHeroAnchor) {
      itinerayHeroAnchor.addEventListener('click', (e) => {
        e.preventDefault();
      });
    }

    document.querySelectorAll('.tour-card__button-brochure').forEach(($downloadBrochureButton) => {
      $downloadBrochureButton.addEventListener('click', () => {
        const tdpLink = $downloadBrochureButton.dataset.tdp.replaceAll('@', '/');
        window.location.href = `${tdpLink}?open_download_brochure=true`;
      });
    });

    const $asyncCssPathElem = $('#async_css_path');
    if ($asyncCssPathElem.length) {
      ['scroll', 'keydown', 'keyup', 'mousemove', 'touchend', 'touchmove'].forEach((e) => {
        window.addEventListener(e, handleInteraction);
      });
    }

    const isLiveChatButtonExist = !!document.getElementById('live-chat');
    const common = {
      sendGoogleEvent,
      sendAmplitudeEvent,
      byUserInteraction,
      parameters,
    };
    this.liveChat = new LiveChat(!isLiveChatButtonExist, common);

    if ($('.js-tours-list').data('ranking-experiment') === 1) {
      exposeSerpManualRankingExperiment();
    }

    initLazyLoad();
    trustBannerInitiate();
    lighthouseNavigationInitiate();
    initializeSaleTopBanner();
    initWindowAction();
    initUserInteraction();
    initResizeMapInit();
    initializeAmplitudeSync();
    initiateAppBanner();
  };
}
